import React from 'react';
import { useIntl } from 'react-intl';
import AccionaBigButton from '../../../../components/AccionaBigButton';
import { useNavigate, useParams } from 'react-router-dom';

const Home = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { id } = useParams();

  return (
    <div className="row">
      <div className="col-xs-12 col-sm-4 col-md-4">
        <AccionaBigButton
          id="mixtures"
          icon="mixture"
          onClick={() => {
            navigate(`/app/project/${id}/strength/thermalControl/mixtures`);
          }}
          msg={intl.formatMessage({ id: `button.mixtures` })}
        />
      </div>
      <div className="col-xs-12 col-sm-4 col-md-4">
        <AccionaBigButton
          id="monitoring"
          icon="monitoring"
          onClick={() => {
            navigate(`/app/project/${id}/strength/thermalControl/monitorings`);
          }}
          msg={intl.formatMessage({ id: `button.monitoring` })}
        />
      </div>
      <div className="col-xs-12 col-sm-4 col-md-4">
        <AccionaBigButton
          id="devices"
          icon="devices"
          onClick={() => {
            navigate(`/app/project/${id}/strength/thermalControl/devices`);
          }}
          msg={intl.formatMessage({ id: `button.devices` })}
        />
      </div>
    </div>
  );
};

export default Home;
